import React from 'react';
import { faTrash } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, DateField, FlexRow, Grid, Header3Text, NumberField, TextField } from 'ui-toolkit/index';

export interface ITaxYearInformationProps {
  index: number;
  baseName: string;
  canDelete: boolean;
  onRemove: () => void;
}

export const TaxYearInformation: React.FC<ITaxYearInformationProps> = ({ index, baseName, canDelete, onRemove }) => {
  return (
    <>
      <FlexRow justifyContent={'space-between'}>
        <Header3Text>Tax Year Information {index + 1}</Header3Text>
        {canDelete && (
          <Button intent="ghost" isInline onClick={onRemove} type="button">
            <FontAwesomeIcon icon={faTrash} />
          </Button>
        )}
      </FlexRow>
      <Grid columnCount={8}>
        <NumberField name={`${baseName}.taxYear`} label="Tax Year" placeholder="Type here" />
        <TextField name={`${baseName}.installNumber`} label="Install Number" placeholder="Type here" />
        <DateField name={`${baseName}.billingPeriodStart`} label="Billing Period Start" placeholder="Type here" />
        <DateField name={`${baseName}.billingPeriodEnd`} label="Billing Period End" placeholder="Type here" />
        <NumberField
          name={`${baseName}.taxesBilledCents`}
          label="Taxes Billed"
          placeholder="Type here"
          mode={'currency'}
          valueIsCents
        />
        <NumberField
          name={`${baseName}.taxesPaidCents`}
          label="Taxes Paid"
          placeholder="Type here"
          mode={'currency'}
          valueIsCents
        />
        <DateField name={`${baseName}.dueDate`} label="Due Date" placeholder="Type here" />
        <TextField name={`${baseName}.status`} label="Status" placeholder="Type here" />
      </Grid>
    </>
  );
};
